// TODO - remove becouse of legacy

import { Selector } from 'reselect'
import { Moment } from 'moment-timezone'
import { ReduxState } from 'store/createRootReducer'

export const datesRangeReportSelector: Selector<ReduxState, [Moment, Moment]> = (state) => state.adSpends.datesRangeReport
export default datesRangeReportSelector
